import { useTranslation } from 'react-i18next'
import { useProfileStore } from '@/reducers'
import { ProfileField } from './ProfileField'

export const InteracInfo = () => {
  const { t } = useTranslation()
  const { interacETransfer } = useProfileStore()

  return (
    <article
      className="grid grid-cols-1 md:grid-cols-2 gap-5"
      data-testid="container-interac-info"
    >
      <ProfileField
        label={t('profile.interacTransfer.questionLabel')}
        value={interacETransfer.question}
        className="md:col-span-2"
      />
      <ProfileField
        label={t('profile.interacTransfer.answerLabel')}
        value={interacETransfer.answer}
        className="md:col-span-2"
      />
    </article>
  )
}
